/** Outer X padding/margin */
var outerX = {
  base: 4,
  lg: 6
};
/** Outer Y padding/margin */

var outerY = {
  base: 4,
  lg: 6
};
/** Inner Y padding/margin */

var innerY = {
  base: 2,
  lg: 4
};
var parts = ['overlay', 'dialogContainer', 'dialog', 'header', 'closeButton', 'body', 'footer'];
var baseStyleOverlay = {
  bg: 'blackAlpha.400',
  zIndex: 'modal'
};
function baseStyleDialogContainer(props) {
  var isCentered = props.isCentered,
    scrollBehavior = props.scrollBehavior;
  return {
    display: 'flex',
    zIndex: 'modal',
    justifyContent: 'center',
    alignItems: isCentered ? 'center' : 'flex-start',
    overflow: scrollBehavior === 'inside' ? 'hidden' : 'auto'
  };
}
function baseStyleDialog(props) {
  var scrollBehavior = props.scrollBehavior;
  return {
    borderRadius: 'md',
    layerStyle: 'card',
    color: 'inherit',
    my: '3.75rem',
    zIndex: 'modal',
    maxH: scrollBehavior === 'inside' ? 'calc(100% - 7.5rem)' : undefined,
    maxW: '3xl',
    px: outerX,
    mx: 4,
    py: outerY
  };
}
var baseStyleHeader = {
  textStyle: 'heading',
  textAlign: 'center',
  fontSize: '2xl',
  paddingBottom: innerY
};
var baseStyleCloseButton = {
  position: 'absolute',
  fontSize: '2xl',
  top: outerY,
  right: outerX,
  boxSize: '1.5rem'
};
function baseStyleBody(props) {
  var scrollBehavior = props.scrollBehavior;
  return {
    textStyle: 'text',
    color: 'gray.400',
    fontSize: 'md',
    '& .chakra-text': {
      color: 'gray.400',
      fontSize: 'md'
    },
    flex: 1,
    overflow: scrollBehavior === 'inside' ? 'auto' : undefined
  };
}
var baseStyleFooter = {
  paddingTop: innerY
};
var baseStyle = function baseStyle(props) {
  return {
    overlay: baseStyleOverlay,
    dialogContainer: baseStyleDialogContainer(props),
    dialog: baseStyleDialog(props),
    header: baseStyleHeader,
    closeButton: baseStyleCloseButton,
    body: baseStyleBody(props),
    footer: baseStyleFooter
  };
};
var defaultProps = {
  isCentered: true
};
var Modal = {
  parts: parts,
  baseStyle: baseStyle,
  defaultProps: defaultProps
};
export { Modal as default };